export default {
  priv: 'pr_reference',
  overviewTitle: 'Verantwoordelijken',
  detailTitle: 'Verantwoordelijke',
  deleteTitle: 'deze verantwoordelijke',
  url: '/references/responsibles',
  apiUrl: '/responsiblecontacts/',
  sortBy: ['name'],
  sortDesc: [false],
  deletable: true,
  editable: true,
  filterName: 'responsiblecontacts',
  quickFilter: {
    text: 'Zoek op naam',
    value: 'name',
    type: 'text'
  },
  tableFields: [
    {
      text: 'Naam',
      value: 'name',
      link: '/references/responsibles/{id}',
      width: '40%'
    },
    {
      text: 'Jobtitel NL',
      value: 'cjobtitle_nl',
      width: '25%'
    },
    {
      text: 'Jobtitel FR',
      value: 'cjobtitle_fr',
      width: '25%'
    }
  ]
};
